import { render, staticRenderFns } from "./childRender.vue?vue&type=template&id=6bf3b1b4&scoped=true"
import script from "./childRender.vue?vue&type=script&lang=js"
export * from "./childRender.vue?vue&type=script&lang=js"
import style0 from "./childRender.vue?vue&type=style&index=0&id=6bf3b1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3b1b4",
  null
  
)

export default component.exports